import React from "react";
import { Link, useNavigate } from "react-router-dom";

import { Button } from "app/components/ui/button";

const drivingworkItems = [
  "No more lost rides due to poor network coverage",
  "Maintain connection in rural areas and delivery dead zones",
  "Get more accurate GPS navigation in challenging coverage areas",
  "Smoother communication with customers and platforms",
];

export const ExclusiveTripleNetwork = () => {
  const navigate = useNavigate();

  return (
    <section>
      <div className="flex flex-col xl:flex-row items-center justify-center bg-[#F7F7F7]">
        <div className="flex-shrink-0 w-full md:w-1/2 max-w-[30rem] md:max-w-[40rem] xl:max-w-[60rem] xl:aspect-square 2xl:aspect-[1.2435/1]">
          <img
            src="/assets/composite-image-man-using-tablet-pc.webp"
            alt="Exclusive Car"
            className="object-cover size-full"
          />
        </div>
        <div className="w-full max-w-[62.75rem] p-6 sm:p-9 md:p-12 lg:p-14 xl:p-10 2xl:p-12 [@media(min-width:1890px)]:p-[5.75rem] xl:pl-0 2xl:pl-0 [@media(min-width:1890px)]:pl-0">
          <div className="p-6 bg-white sm:p-9 md:p-12 lg:p-14 xl:p-10 2xl:p-12 [@media(min-width:1890px)]:p-20 [@media(min-width:1890px)]:pr-40">
            <h2 className="font-mobile text-[#1D1D1B] text-[clamp(1.5rem,calc(2.5vw+1rem),3.125rem)] font-normal leading-snug md:leading-normal lg:leading-[4rem] mb-1.5 sm:mb-2 lg:mb-2.5">
              Exclusive Car Title Monitoring Included
            </h2>
            <p className="text-[#1D1D1B] text-sm sm:text-[0.925rem] lg:text-base font-normal leading-5 sm:leading-6 lg:leading-7">
              Did you know your car title could be stolen? Car title theft (also
              called vehicle title fraud or title washing) occurs when someone
              illegally transfers ownership of your vehicle without your
              permission. Criminals use your information to forge documents,
              clone vehicles, and commit insurance fraud. <br /> <br />
              VLE Mobile is the only mobile carrier in the US that includes car
              title monitoring service for free with our comprehensive online
              security and identity theft protection package. <br /> <br />
              <Link
                to="/digital-security"
                className="text-[#FE4D01] hover:text-[#E44501] hover:underline font-semibold"
              >
                Click here to learn more
              </Link>{" "}
              about all the features our protection service includes.
            </p>
          </div>
        </div>
      </div>
      <div className="bg-white px-5 sm:px-6 md:px-7 lg:px-9 xl:px-12 py-9 sm:py-14 md:py-[5.5rem] lg:py-[7.5rem]">
        <div className="flex flex-col lg:flex-row items-center justify-center gap-6 sm:gap-9 md:gap-11 lg:gap-14 xl:gap-16 2xl:gap-20 bg-white w-full max-w-[90.75rem] px-6 sm:px-8 lg:px-[2.375rem] py-9 sm:py-11 lg:py-[3.125rem] mx-auto shadow-[0_0_1.25rem_0_rgba(0,0,0,0.05)]">
          <div className="lg:order-2 w-full max-w-[31.25rem] aspect-square rounded-lg overflow-hidden">
            <img
              src="/assets/gps-cartography-concept.webp"
              alt="GPS Cartography Concept"
              className="object-cover size-full"
            />
          </div>
          <div className="lg:order-1 w-full lg:max-w-[37.5rem] 2xl:max-w-[42rem] mx-auto lg:mx-0 2xl:mx-0">
            <div className="text-center lg:text-left">
              <h2 className="font-mobile text-[#1D1D1B] text-[clamp(1.5rem,calc(2.5vw+1rem),3.125rem)] font-normal leading-snug md:leading-normal lg:leading-[4.375rem] mb-0.5 sm:mb-0">
                Triple Network Access: Game-Changer for Platform Drivers
              </h2>
              <p className="text-[#64748B] text-sm sm:text-[0.9375rem] lg:text-[1.0625rem] font-medium leading-5 sm:leading-[1.375rem] lg:leading-6">
                Only VLE Mobile gives you access to all three major US networks
                with a single plan, switching automatically to keep you
                connected wherever the job takes you.
              </p>
            </div>
            <p className="text-[#1A0F33] text-sm sm:text-[0.9375rem] lg:text-[1.0625rem] font-bold leading-[1.125rem] sm:leading-5 lg:leading-6 my-3 sm:my-3.5 lg:my-4">
              What this means for your driving work:
            </p>
            <ul className="space-y-2 sm:space-y-[0.5625rem] lg:space-y-[0.585rem] mb-3.5 sm:mb-4 lg:mb-5">
              {drivingworkItems.map((item, index) => (
                <li
                  key={index}
                  className="flex items-center gap-2.5 sm:gap-3 lg:gap-4"
                >
                  <img
                    src="/assets/tick-circle-orange.svg"
                    alt="Tick"
                    className="size-5 sm:size-6 md:size-7 lg:size-8 shrink-0"
                  />
                  <p className="text-[#1A0F33] text-sm sm:text-[0.925rem] lg:text-base font-medium leading-[1.125rem] sm:leading-5 lg:leading-[1.4rem]">
                    {item}
                  </p>
                </li>
              ))}
            </ul>
            <Button
              type="button"
              variant="blackBtn"
              className="max-w-80 sm:max-w-[21.875rem] lg:max-w-[25.5rem] h-12 sm:h-14 lg:h-[4.25rem] text-white [@media(max-width:400px)]:text-xs leading-[0.875rem] sm:leading-[0.9375rem] lg:leading-4"
              onClick={() => navigate("/network-plan")}
            >
              {/* For Limited Time Get Your First Month For $1 */}
              For Limited Time Get Your First Month
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};
